import React from "react";
import "./OctagonTab.scss";

interface OctagonTabProps<T = any> {
    text: string;
    onClick?: (data: T) => void | Promise<void>;
    isActive?: boolean;
    className?: string;
    large?: boolean;
}

export const OctagonTab: React.FC<OctagonTabProps> = React.memo(({ text, onClick, isActive, className, large}) => {
    return (
        <button className={'octagon-tab' + ' ' + (isActive ? 'active' : '') + ' ' + (large ? 'large' : '')} onClick={onClick}>
            <span className="octagon-tab-text">{text}</span>
        </button>
    )
});